var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/src/array.js
// module id = 63
// module chunks = 0 1